module.exports = __webpack_public_path__ + "static/media/group_message.3174b6ac.png";